export default function RightToolbar() {
  return (
    <div className="mail-right-toolbar">
      <div className="mail-icons">
        <div className="mail-icon-item">
          <span className="material-icons-outlined">apps</span>
        </div>
        <div className="mail-icon-item">
          <span className="material-icons-outlined">add</span>
        </div>
        <div className="mail-icon-item">
          <span className="material-icons-outlined">person</span>
        </div>
        <div className="mail-icon-item">
          <span className="material-icons-outlined">check_circle</span>
        </div>
        <div className="mail-icon-item">
          <span className="material-icons-outlined">label_important</span>
        </div>
        <div className="mail-icon-item bottom">
          <span className="material-symbols-outlined">arrow_forward</span>
        </div>
      </div>
    </div>
  );
}
